<template>
  <vx-card>
    <main>
      <div class="mt-5">
        <vs-tabs>
          <vs-tab label="Penerima Manfaat">
            <div class="tab-text">
              <tabel-penerima-manfaat
                :campaignDetail="campaignDetail"
              ></tabel-penerima-manfaat>
            </div>
          </vs-tab>
          <vs-tab label="Donatur">
            <div class="tab-text">
              <tabel-transaksi-masuk
                :campaignDetail="campaignDetail"
              ></tabel-transaksi-masuk>
            </div>
          </vs-tab>
          <vs-tab label="Referal">
            <div class="tab-text">
              <tabel-referal :campaignDetail="campaignDetail"></tabel-referal>
            </div>
          </vs-tab>
          <!-- <vs-tab label="Transaksi">
            <div class="tab-text">
            </div>
          </vs-tab> -->
        </vs-tabs>
      </div>
    </main>
  </vx-card>
</template>
<script>
import TabelPenerimaManfaat from "@/views/campaign/component/tabs-content/TabelPenerimaManfaat.vue";
import TabelTransaksiMasuk from "@/views/campaign/component/tabs-content/TabelTransaksiMasuk.vue";
import TabelReferal from "@/views/campaign/component/tabs-content/TabelReferal.vue";

export default {
  props: {
    campaignDetail: { type: Object, default: {} },
  },
  components: {
    TabelPenerimaManfaat,
    TabelTransaksiMasuk,
    TabelReferal,
  },
};
</script>
